import { fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import { message } from 'antd';

const GET_CONFERENCE_SUCCESS = 'modules/Conference/GET_CONFERENCE_SUCCESS';
const TOGGLE_LOADING_MASK = 'modules/global/TOGGLE_LOADING_MASK';

const initialState = fromJS({
  conference: {},
});

const reducer = handleActions({
  [GET_CONFERENCE_SUCCESS]: (state, action) => state.set('conference', fromJS(action.payload.conference)),
  [TOGGLE_LOADING_MASK]: (state) => {
    return state
      .setIn(['ui', 'loadingMask'], !state.getIn(['ui', 'loadingMask']));
  },
}, initialState);

const getConferenceSuccess = createAction(GET_CONFERENCE_SUCCESS, (conference) => ({ conference }));

export const getConference = () => (dispatch, getState, { api }) => {
  api.get(`/conferences/${process.env.REACT_APP_CONFERENCE_ID}`)
    .then((response) => {
      dispatch(getConferenceSuccess(response.data));
    })
    .catch((err) => message.error(err.message, 5));
};
export const toggleLoadingMask = createAction(TOGGLE_LOADING_MASK);

export const createSubscription = (payload, callback) => {
  return async function (dispatch, getState, { ac }) {
    try {
      dispatch(toggleLoadingMask());
      const response = await ac.post('/signup', payload);
      const { data } = response;
      const resultCode = data.result_code;

      dispatch(toggleLoadingMask());
      if (resultCode !== 1) {
        message.error('Oops, something went wrong. Please try again. Thanks!', 5);
        return;
      }

      callback();
      message.success('Thank you, please check your email.', 5);
    } catch (err) {
      dispatch(toggleLoadingMask());
      message.error(err.message, 5);
    }
  };
};

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/global.js